import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { eggColorChart } from "../../services/Chart";
import Shimmer from "../shimmer";
import Notfound from "../data-not-found";
import { useSelector } from "react-redux";

// import { eggColorChart } from "../services/addEgg";

const EggColorChart = ({ chartRef2 }) => {
  const zoneRefresh = useSelector((state) => state.updateZone.value);
  const [series, setSeries] = useState([]);
  const [loader, setLoader] = useState(true);
  const [labels, setLabels] = useState([]);

  const mapSeriesData = async () => {
    let startDate = localStorage.getItem("startDate");
    let endDate = localStorage.getItem("endDate");
    let regionId = localStorage.getItem("selectedZone");
    const seriesTemp = [];
    const labelsTemp = [];
    const response = await eggColorChart(regionId, startDate, endDate);
    if (response.status) {
      setLoader(false);

      response?.data?.forEach((element) => {
        if (element !== null) {
          seriesTemp.push(element?.totalAmount);
        }
      });

      response?.data?.forEach((element) => {
        if (element !== null) {
          labelsTemp.push(element?.colorDetails?.name);
        }
      });

      setLabels([...labelsTemp]);
      setSeries([...seriesTemp]);
    }
  };

  useEffect(() => {
    mapSeriesData();
  }, [zoneRefresh]);

  const chartOptions = {
    series: [],
    options: {
      stroke: {
        width: 0,
      },
      colors: ["#F17456", "#263658"],
      plotOptions: {
        pie: {
          donut: {
            size: "60%",
          },
        },
      },
      labels: labels,
      legend: {
        position: "bottom",
      },
      chart: {
        type: "donut",
        toolbar: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: false,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
            customIcons: [],
          },
          export: {
            csv: {
              filename: "EggProductionColorChart.csv",
              columnDelimiter: ",",
              headerCategory: "category",
              headerValue: "value",
              dateFormatter(timestamp) {
                return new Date(timestamp).toDateString();
              },
            },
            svg: {
              filename: "EggProductionColorChart.svg",
            },
            png: {
              filename: "EggProductionColorChart.png",
            },
          },
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
          },
        },
      ],
    },
  };

  return (
    <>
      {/* <Shimmer/> */}

      {loader ? (
        <Shimmer />
      ) : (
        <div id="chart">
          {series.length > 0 ? (
            <div>
              <ReactApexChart
                options={chartOptions.options}
                series={series}
                type="donut"
              />
            </div>
          ) : (
            <Notfound />
          )}
        </div>
      )}
    </>
  );
};
export default EggColorChart;
